export default {
  CI: process.env.REACT_APP_CI,
  API_BASE_URL: "https://aqueous-dusk-78313.herokuapp.com/api",
  TOKEN_KEY: 'activities-assistant-auth-token',
  orgs_endpoint: "https://aqueous-dusk-78313.herokuapp.com/api/orgs",
  users_endpoint: "https://aqueous-dusk-78313.herokuapp.com/api/users",
  activities_endpoint: "https://aqueous-dusk-78313.herokuapp.com/api/activities",
}